import React from "react";
import "./EditContainerView.css";
import {Button} from "react-bootstrap";
import {useEditContext} from "./EditContext";

const EditContainerView = () => {
  const {editNode, setEditNode} = useEditContext();

  if (!editNode) {
    return null;
  }

  return (
    <div className="EditContainerView">
      <div className="EditContainerView-close">
        <Button variant="outline-secondary" onClick={() => setEditNode(null)}>
          X
        </Button>
      </div>
      <div className="EditContainerView-content">{editNode}</div>
    </div>
  );
};

export default EditContainerView;
